<template>
  <main style="margin:auto" :style="{ width: $vuetify.breakpoint.smAndDown ? '80vw' : '50vw' }">
    <h2 class="pb-3">Сессия подписания успешно оплачена.</h2>
    <p>Все данные сессии: ФИО и ID участников, документы и другие служебные данные безвозвратно удалены.</p>
    <p>Результат завершения сессии подписания был направлен всем участникам соответствующим образом.</p>
  </main>
</template>
<script>
export default {
  name: 'PaymentSuccess',
}
</script>
<style lang="scss">
// http://localhost:8080/#/payment/success/c0b17468-d478-44ad-9e3d-3fb3506f84b4/0a932f74-62dd-46cb-9c57-5c6897fde5a8
</style>